export const MENU_TEXT_TYPE = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
} as const;

export type MENU_TEXT_TYPE_KEY = keyof typeof MENU_TEXT_TYPE;
export type MENU_TEXT_TYPE_VALUE = typeof MENU_TEXT_TYPE[MENU_TEXT_TYPE_KEY];

export const MENU_TEXT_TYPE_MAP = {
  [MENU_TEXT_TYPE.LEFT]: '왼쪽 정렬',
  [MENU_TEXT_TYPE.CENTER]: '중앙 정렬',
  [MENU_TEXT_TYPE.RIGHT]: '오른쪽 정렬',
};

export const menuTextTypeList = Object.keys(MENU_TEXT_TYPE_MAP).map((key) => {
  return {
    key: key,
    value: MENU_TEXT_TYPE_MAP[key],
  };
});
